import { createAction } from '@reduxjs/toolkit';

export const fetchAcademicTitlesRequestAction = createAction<{}, 'FETCH_ACADEMIC_TITLES_REQUEST'>('FETCH_ACADEMIC_TITLES_REQUEST');
export const fetchAcademicTitlesSuccessAction = createAction<{ items: Array<{ _id: string; title: string }> }, 'FETCH_ACADEMIC_TITLES_SUCCESS'>(
  'FETCH_ACADEMIC_TITLES_SUCCESS'
);
export const fetchAcademicTitlesErrorAction = createAction<{}, 'FETCH_ACADEMIC_TITLES_ERROR'>('FETCH_ACADEMIC_TITLES_ERROR');
